export enum MapType {
    Default = 'default',
    Aero = 'aero'
}


export enum MapQueryParams {
    MapType = 'map-type'
}